import OrderUpload from "./OrderUpload";

export default OrderUpload;
